import React, {useEffect, useState} from 'react';
import {Icon, Modal, Button, Table, Loader, Popup} from 'semantic-ui-react';
import VehiclesModalTable from './vehiclesModalTable';
import {getColumns} from './vehiclesModalTableColumns';
import {useDispatch, useSelector} from 'react-redux';

import {Actions} from '../../../../common/actions';

const {
  fetchCandidateVehicles,
  clearCandidateVehicles,
} = Actions;

const VehiclesModal = ({
  changeVehiclesArray,
  checkVehSelected,
  maxVehiclesSelected,
  loading,
  formValues,
}) => {
  const [showModal, setShowModal] = useState(false);
  const candidatesVehicles = useSelector((state) => state.candidateVehicles.list.map((x) => {
    return {...x, 'hunter': x.hunter ? 'SI' : 'NO'};
  }));
  const dealersList = useSelector((state) => state.dealer.list);
  const vehiclesTypesList = useSelector((state) => state.vehiclesTypes.list);

  const dispatch = useDispatch();

  useEffect(() => {
    if (showModal) {
      dispatch(fetchCandidateVehicles(formValues.dealerId, formValues.type, formValues.anticipatedInvoice));
    } else {
      dispatch(clearCandidateVehicles());
    }
  }, [showModal]);

  const handleShowModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  const isVehSelected = (vehicle) => {
    return checkVehSelected(vehicle);
  };

  const handleChangeCheck = (e, item, action) => {
    e.preventDefault();
    return changeVehiclesArray(item, action);
  };

  const hideAddVehiclesButton = () => {
    const {status} = formValues;
    return !status || status === 'I' ? true : false ? '' : 'hide';
  };

  const state = {
    'data': [],
    'vehiclesSelectedOnModal': [],
    'columns': getColumns({
      'handleChangeCheck': handleChangeCheck.bind(this),
      'maxVehiclesSelected': maxVehiclesSelected.bind(this),
      'isVehSelected': isVehSelected.bind(this),
    }),
  };

  const renderHeader = () => {
    return (
      <div className='header flex'>
        <div className='flex grow middle'>
          <h2 style={{'margin': 0}}>Vehículos disponibles</h2>
          <Popup wide='very' trigger={
            <Icon className='info circle' name='info' size='large' color='blue' style={{'cursor': 'pointer'}} />}
          content={
            <>
              <h4 style={{'margin': 0}}>Vehículos de</h4>
              <ul style={{'margin': 0}}>
                <li>{dealersList.find((x) => x.identification === formValues.dealerId)?.name}</li>
                <li>{vehiclesTypesList.find((x) => x.code === formValues.type)?.description}</li>
                <li>{formValues.anticipatedInvoice === 'S' ? 'FACTURACIÓN ANTICIPADA' : 'FACTURACIÓN NORMAL'}</li>
              </ul>
              <h4 style={{'margin': 0}}>que se encuentren</h4>
              <ul style={{'margin': 0}}>
                <li>en stock</li>
                <li>listos</li>
                <li>disponibles</li>
                <li>no estén asignado a una O/T</li>
                {formValues.anticipatedInvoice === 'S' ? <li>tengan accesorios reservados</li> : ''}
              </ul>
            </>
          } />
        </div>
        <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
          onClick={(e) => handleShowModal(e, false)} />
      </div>
    );
  };

  const {columns} = state;
  return (
    <Modal size={'fullscreen'} header={renderHeader()} open={showModal}
      trigger={
        formValues.dealerId && formValues.type && formValues.anticipatedInvoice && formValues.notificateTo ?
          <Popup inverted content='Agregar vehículos' trigger={
            <Icon link size='huge' className={`add-circle ${hideAddVehiclesButton()}`}
              color='green'
              hidden={!(!formValues.status || formValues.status === 'I')}
              onClick={(e) => handleShowModal(e, true)} />
          } /> : ''
      }
      closeOnEscape={false} closeOnDimmerClick={false}
      content={
        <div className="m-2" style={{'marginBottom': 0}}>
          <div className='flex' style={{'marginBottom': '1em'}}>
            <h3 className='flex grow middle' style={{'margin': 0}}>
              Seleccione los vehículos que desee añadir a la orden de despacho</h3>
          </div>
          {loading ?
            <Table>
              <Table.Body>
                <Table.Row className='loader'>
                  <Table.Cell colSpan='100%'>
                    <Loader active inline='centered' />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table> :
            <VehiclesModalTable columns={columns} data={candidatesVehicles}
              maxVehiclesSelected={maxVehiclesSelected.bind(this)}
              handleChangeCheck={handleChangeCheck.bind(this)}
              isVehSelected={isVehSelected.bind(this)} />
          }
          <div className='flex' style={{'justifyContent': 'center', 'padding': '10px'}}>
            <div>
              <Button primary className='download' onClick={(e) => handleShowModal(e, false)}>
                <Icon name='check' />
                <span>Aceptar</span>
              </Button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default VehiclesModal;
